<script setup>
import { Primitive } from 'reka-ui';
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false, default: 'div' },
});
</script>

<template>
  <Primitive
    data-slot="bubble-content"
    :as="as"
    :as-child="asChild"
    :class="
      cn(
        'rounded-polaris-xl border border-solid border-transparent px-3 py-2 text-sm leading-relaxed [&:is(button,a)]:outline-none [&:is(button,a)]:focus-visible:border-polaris-ring [&:is(button,a)]:focus-visible:ring-[3px] [&:is(button,a)]:focus-visible:ring-polaris-ring/50 group-data-[align=end]/bubble:self-end w-fit max-w-full min-w-0 overflow-hidden break-words [&:is(button)]:text-left [&:is(button,a)]:transition-colors',
        props.class
      )
    "
  >
    <slot />
  </Primitive>
</template>
